import {learnTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = learnTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const learnReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default learnReducer;
